import { useState } from 'react';
import PropTypes from 'prop-types';

const CONFIRM_WORD = 'DELETE';

export default function DeleteAccountModal({onConfirm, onCancel}) {
    const [typed, setTyped] = useState('');
    const ready = typed === CONFIRM_WORD;

    function handleKeyDown(e) {
        if (e.key === 'Enter' && ready) onConfirm();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop delete-account-backdrop"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="delete-account-modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={handleKeyDown}
                role="dialog"
                aria-modal="true"
                aria-labelledby="delete-account-title"
            >
                <h3 className="delete-account-title" id="delete-account-title">
                    Delete account
                </h3>

                <div className="delete-account-consequences">
                    <p className="delete-account-consequence">
                        <span className="delete-account-bullet">·</span>
                        Your account will be permanently removed
                    </p>
                    <p className="delete-account-consequence">
                        <span className="delete-account-bullet">·</span>
                        All checklists and items will be destroyed
                    </p>
                    <p className="delete-account-consequence">
                        <span className="delete-account-bullet">·</span>
                        This action cannot be undone
                    </p>
                </div>

                <div className="delete-account-confirm-field">
                    <label className="delete-account-label" htmlFor="delete-confirm-input">
                        Type <span className="delete-account-keyword">{CONFIRM_WORD}</span> to confirm
                    </label>
                    <input
                        id="delete-confirm-input"
                        className={`delete-account-input${ready ? ' delete-account-input--ready' : ''}`}
                        type="text"
                        value={typed}
                        onChange={e => setTyped(e.target.value.toUpperCase())}
                        placeholder={CONFIRM_WORD}
                        autoComplete="off"
                        autoFocus
                        spellCheck={false}
                    />
                </div>

                <div className="delete-account-actions">
                    <button className="modal-cancel" onClick={onCancel}>Cancel</button>
                    <button
                        className="delete-account-submit"
                        onClick={onConfirm}
                        disabled={!ready}
                    >
                        Delete account
                    </button>
                </div>
            </div>
        </div>
    );
}

DeleteAccountModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
